import { useEffect, useState } from "react"
import axios from 'axios';
import { FaInfoCircle } from "react-icons/fa";
import { properties } from "../assets/properties";
import validate from './validate';
import { useForm } from './customHooks';
import { PageNotFound } from './PageNotFound';
import { GenerateDropdownOptions } from "./GenerateDropdownOptions";
import { ResponseMsg } from './ResponseMsg';
import { ConfirmDialogbox } from "./ConfirmDialogbox";
import { PaymentMethodAccordion } from "./PaymentMethodAccordion";
import { env } from "../env";
import { Tooltip } from "./Tooltip";

export function ViewEditClientApplication(props) {

    const { appId } = props.match.params;
    const baseURL = env.REACT_APP_BASE_URL;
    const [clientAppData, setClientAppData] = useState({});
    const [showPageNotFound, setPageNotFound] = useState(false);
    const [fetchedResult, setFetchedResult] = useState(false);
    const [typeList, setTypeList] = useState({});
    const [businessUnitList, setBusinessUnitList] = useState({});
    const [paymentMethodList, setPaymentMethodList] = useState([]);
    const [inputPaymentsData, setInputPaymentsData] = useState([]);
    const [statusOptionList, setStatusOptionList] = useState({});
    const [clientAdmins, setClientAdmins] = useState({});
    const [clientAppUpdateUrl, setClientAppUpdateUrl] = useState();
    const [promotionId, setPromotionId] = useState();
    const [showPaymentAccordion, setShowAccordion] = useState(false);
    let usedInputs = [];
    let initialValues = {};

    const ValueForDynamicPMC = (data) => {
        if (data instanceof Array) {
            let dynamicPMC = "";
            data.length && data?.map((element, index) => {
                dynamicPMC += (element.pmc_id + ":" + element.regionName)
                if(index != (data.length - 1)) {
                    dynamicPMC+=";"
                }
            })
            updateData(inputs => ({ ...inputs, "dynamicPaymentMethodConfigurations": dynamicPMC }));
            return dynamicPMC;
        } else {
            return data;
        }
    }

    if (props.registerPermission) {
        usedInputs = ['type', 'businessUnit', 'name', 'appShortName', 'template', 'targetUrl', 'lansaUrl', 'userId', 'paymentDTOs', 'dynamicPaymentMethodConfigurations', 'overCaptureFlag'];
        initialValues = { type: '', businessUnit: '', name: '', appShortName: '', template: '', targetUrl: '', lansaUrl: '', userId: '', paymentDTOs: [], dynamicPaymentMethodConfigurations: [], overCaptureFlag: false };
    } else if (props.addPermission && props.role === properties.dbRoleList.WPS_ADMIN) {
        usedInputs = ['type', 'businessUnit', 'name', 'appShortName', 'secret', 'template', 'targetUrl', 'lansaUrl', 'userId', 'paymentDTOs', 'dynamicPaymentMethodConfigurations', 'overCaptureFlag'];
        initialValues = { type: '', businessUnit: '', name: '', appShortName: '', secret: '', template: '', targetUrl: '', lansaUrl: '', userId: '', paymentDTOs: [], dynamicPaymentMethodConfigurations: [], overCaptureFlag: false };
    } else {
        usedInputs = ['type', 'businessUnit', 'name', 'appShortName', 'secret', 'template', 'targetUrl', 'lansaUrl', 'status', 'userId', 'paymentDTOs', 'dynamicPaymentMethodConfigurations', 'overCaptureFlag'];
        initialValues = { type: '', businessUnit: '', name: '', appShortName: '', secret: '', template: '', targetUrl: '', lansaUrl: '', status: '', userId: '', paymentDTOs: [],  dynamicPaymentMethodConfigurations: [], overCaptureFlag: false };
    }
    const cancelUrl = (props.approvalPermission) ? "goback" : (props.promotePermission ? "gotopromote" : "");
    const ClassNameList = (props.approvalPermission) ? " approve-client-app" : "";
    const restrictedStatList = props.restrictedStatList;

    const {
        inputs,
        errors,
        actionResp,
        confirmMsg,
        handleSubmit,
        handleInputChange,
        cancelRegister,
        updateData,
        openModal,
        isTargetMandatory,
        setIsTargetMandatory } = useForm(initialValues, validate, props.tokenId, clientAppUpdateUrl, cancelUrl);

    useEffect(() => {
        setTypeList(properties.typeList);
        setBusinessUnitList(properties.businessUnitList);
    }, [])

    const onChangePaymentMethod = (selectedPayments, e) => {
        handleInputChange({
            ...e, target: { ...e.target, id: e.target.id, value: selectedPayments, classList: e.target.classList, name: "paymentDTOs" },
        })
    }

    const onChangeOverCapture = (e) => {
        handleInputChange({
            ...e, target: { ...e.target, id: e.target.id, value: e.target.checked, classList: e.target.classList, name: "overCaptureFlag" },
        })
    }

    const fetchClientApplicationDetails = async () => {
        const clientApplicationUrl = properties.apiList.clientApplicationUrl.replace("[clientAppId]", appId);
        try {
            const clientAppRes = await axios.get(baseURL + clientApplicationUrl,
                {
                    headers: {
                        "Authorization": 'Bearer ' + props.tokenId
                    }
                })
            let clientAppPaymentData = clientAppRes.data.paymentDTOs;
            clientAppPaymentData.forEach((item) => {
                item.id = "chk_" + item.id;
            });
            setInputPaymentsData(clientAppPaymentData);
            const sortedpaymentmethod = sortPaymentMethodList(clientAppPaymentData);
            setPaymentMethodList(sortedpaymentmethod);
            
            setClientAppData(clientAppRes.data);
            setPromotionId(clientAppRes.data.action.clientPromotionId)
            if ((clientAppRes.data.type === properties.typeList.SOAP) || (clientAppRes.data.type === properties.typeList.PUBLIC)) {
                setIsTargetMandatory(false);
                properties.FormFieldNames.targetUrl.required = false;
                properties.FormFieldNames.template.required = false;
            } else {
                setIsTargetMandatory(true);
                properties.FormFieldNames.targetUrl.required = true;
                properties.FormFieldNames.template.required = true;
            }
            Object.keys(clientAppRes.data).length > 0 && setPageNotFound(true);

            setClientAppUpdateUrl(properties.apiList.submitEditClientAppUrl.replace("{clientAppId}", clientAppRes.data.clientAppId))

            const filteredUsedInputs = Object.keys(clientAppRes.data)
                .filter(key => usedInputs.includes(key))
                .reduce((obj, key) => {
                    obj[key] = clientAppRes.data[key];
                    return obj;
                }, {});

            updateData(filteredUsedInputs);
        }
        catch (e) {
            setPageNotFound(true);
        }
    }

    const fetchRegionPaymentMethodForClientApp = async () => {
        const clientApplicationUrl = properties.apiList.paymentMethodTypesForRegionUrl.replace("[clientAppId]", appId);
        try {
            let clientAppRes = await axios.get(baseURL + clientApplicationUrl,
                { headers: { "Authorization": 'Bearer ' + props.tokenId } })
            let clientAppResData = clientAppRes.data;
            clientAppResData.forEach((item) => {
                item.id = "chk_" + item.id;
            });
            setInputPaymentsData(clientAppResData);
            const sortedpaymentmethod = sortPaymentMethodList(clientAppResData);
            setPaymentMethodList(sortedpaymentmethod);
        }
        catch (e) {
            setPageNotFound(true);
        }
    }
    const fetchStatusOptionData = async () => {
        try {
            let statusList = [];
            if (!props.editPermission && !props.addPermission && !props.registerPermission) {
                //disabled field
                if (props.approvalPermission) {
                    statusList[clientAppData.status] = properties.statusList[clientAppData.status];
                }
                else {
                    statusList[clientAppData.status] = properties.filteredStatusList[clientAppData.status];
                }
            }
            else {
                //enabled field

                // const statusOptionRes = await axios.get(baseURL + properties.apiList.fetchStatus,
                //     {
                //         headers: {
                //             "Authorization": 'Bearer ' + props.tokenId
                //         }
                //     }
                // )
                const statusOptionRes = { data: properties.statusList };

                if (props.approvalPermission) {
                    Object.keys(statusOptionRes.data).forEach(el => {
                        if (properties.statusList[el] !== undefined) {
                            statusList[el] = properties.statusList[el];
                        }
                    })
                }
                else {
                    Object.keys(statusOptionRes.data).forEach(el => {
                        if (properties.filteredStatusList[el] !== undefined) {
                            statusList[el] = properties.filteredStatusList[el];
                        }
                    })
                }
            }
            setStatusOptionList(statusList);
        } catch (e) {
        }
    }

    const fetchClientAdmins = async () => {
        try {
            let clientAdminArr = [];
            if (!props.editPermission && !props.addPermission && !props.registerPermission) {
                //disabled field
                clientAdminArr = [clientAppData.ssoId];
            }
            else {
                //enabled field
                const clientAdminRes = await axios.get(baseURL + properties.apiList.fetchClientAdmins.replace("{adminRole}", "Client_Admin"),
                    {
                        headers: {
                            "Authorization": 'Bearer ' + props.tokenId
                        }
                    }
                )
                clientAdminRes.data.forEach(el => {
                    clientAdminArr[el.userId] = el.ssoId;
                })
            }
            setClientAdmins(clientAdminArr);
        } catch (e) {
        }
    }

    const sortPaymentMethodList = (paymentMethodList) => {
        const regionMap = new Map();

        paymentMethodList.forEach(item => {
            if (!regionMap.has(item.region)) {
                regionMap.set(item.region, []);
            }
            regionMap.get(item.region).push(item);
        })

        const result = [];

        regionMap.forEach(items => {
            const paymentCategoryMap = new Map();

            items.forEach(item => {
                if (!paymentCategoryMap.has(item.paymentCategory)) {
                    paymentCategoryMap.set(item.paymentCategory, []);
                }
                paymentCategoryMap.get(item.paymentCategory).push(item);
            })

            paymentCategoryMap.forEach(paymentItems => {
                result.push(...paymentItems);
            })
        })
        return result;
    }

    const defaultPaymentMethodTypesForRegionUrl = async () => {
        try {
            const paymentMethodRes = await axios.get(baseURL + properties.apiList.defaultPaymentMethodTypesForRegionUrl,
                { headers: { "Authorization": 'Bearer ' + props.tokenId } }
            )
            let res1 = paymentMethodRes.data;
            res1.forEach((item) => {
                item.id = "chk_" + item.id;
            });
            const sortedpaymentmethod = sortPaymentMethodList(res1);
            setPaymentMethodList(sortedpaymentmethod);
            if (props.addPermission || props.registerPermission) {
                setInputPaymentsData(res1);
                initialValues.paymentDTOs = res1;
                updateData(initialValues);
            }
        } catch (e) {
            console.log(e);
        }
    }

    const fetchSecretKey = async () => {
        try {
            const secretKey = await axios.get(baseURL + properties.apiList.getSecretKeyUrl,
                {
                    headers: {
                        "Authorization": 'Bearer ' + props.tokenId
                    }
                }
            )
            initialValues.secret = secretKey.data;
            initialValues.userId = "";
            updateData(initialValues);
        } catch (e) {
        }
    }

    useEffect(() => {
        if (window.location.pathname === "/new-client-application") {
            defaultPaymentMethodTypesForRegionUrl();
        }
    }, []);

    useEffect(() => {
        if (!props.addPermission && !props.registerPermission) {
            fetchClientApplicationDetails();
            // fetchRegionPaymentMethodForClientApp();
        }
        setFetchedResult(true);
        if (props.addPermission || props.registerPermission) {
            setClientAppUpdateUrl(properties.apiList.addRegisterNewClientApplicationUrl)
            properties.FormFieldNames.targetUrl.required = false;
        }
        if (props.addPermission) {
            fetchSecretKey();
        }
    }, []);

    useEffect(() => {
        if (fetchedResult) {
            fetchStatusOptionData();
            fetchClientAdmins();
        }
    }, [fetchedResult, clientAppData]);


    let hasPermission = (Object.keys(clientAppData).length > 0 && (props.viewPermission || props.editPermission || (props.rollbackPermission && clientAppData.action.rollback) || props.approvalPermission || props.promotePermission));
    let addOrRegisterApp = (props.registerPermission || props.addPermission);
    return (
        <>
            <ResponseMsg msg={actionResp} />
            {confirmMsg !== "" && <ConfirmDialogbox confirmMsg={confirmMsg} appId={appId} promotionId={promotionId} appData={inputs} tokenId={props.tokenId} />}
            {(addOrRegisterApp || (hasPermission && restrictedStatList.includes(inputs["status"]))) ?
                <div className={"reg-nw-user" + ClassNameList}>
                    <h1 className="margin-top-zero">
                        {props.editPermission ? properties.pageHeaders.editClientApplicationHeader :
                            props.approvalPermission ? properties.pageHeaders.approveDeclineClientApplicationHeader :
                                props.promotePermission ? properties.pageHeaders.promoteClientApplicationHeader :
                                    props.addPermission ? properties.pageHeaders.addNewClientApplication :
                                        props.registerPermission ? properties.pageHeaders.registerNewClientApplication :
                                            props.rollbackPermission ? properties.pageHeaders.rollbackClientApplication : properties.pageHeaders.viewClientApplicationHeader}
                    </h1>
                    <form method="post" className="reg-nw-user-form" onSubmit={(e) => handleSubmit(e, (props.addPermission || props.registerPermission) ? properties.methodList.POST : properties.methodList.PUT, props.editPermission ? properties.messageList.editClientAppSuccessMsg : props.addPermission ? properties.messageList.addNewClientApplicationMsg : properties.messageList.registerNewClientApplicationMsg, (props.addPermission || props.registerPermission) ? properties.TRUE : properties.FALSE)}>
                        <div className="row form-group">
                            <label htmlFor="type">{properties.FormFieldNames.type.fieldName}<span>*</span></label>
                            <select className="form-control" name="type" id="type" value={inputs["type"]} onChange={handleInputChange} disabled={!props.editPermission && !props.addPermission && !props.registerPermission} >
                                <option value="" disabled={true}>{properties.SELECT}</option>
                                <GenerateDropdownOptions dataList={typeList} />
                            </select>
                            {errors.type && <span className="input-err-msg">{errors.type}</span>}
                        </div>
                        <div className="row form-group">
                            <label htmlFor="businessUnit">{properties.FormFieldNames.businessUnit.fieldName}<span>*</span></label>
                            <select className="form-control" name="businessUnit" id="businessUnit" value={inputs["businessUnit"]} onChange={handleInputChange} disabled={!props.editPermission && !props.addPermission && !props.registerPermission}>
                                <option value="" disabled={true}>{properties.SELECT}</option>
                                <GenerateDropdownOptions dataList={businessUnitList} />
                            </select>
                            {errors.businessUnit && <span className="input-err-msg">{errors.businessUnit}</span>}
                        </div>
                        <div className="row form-group">
                            <label htmlFor="name">{properties.FormFieldNames.name.fieldName}<span>*</span></label>
                            <input type="text" name="name" className="form-control" id="name" onChange={handleInputChange} placeholder="" value={inputs.name} disabled={!props.editPermission && !props.addPermission && !props.registerPermission} />
                            {errors.name && <span className="input-err-msg">{errors.name}</span>}
                        </div>
                        <div className="row form-group">
                            <label htmlFor="appShortName">{properties.FormFieldNames.appShortName.fieldName}<span>*</span></label>
                            <input type="text" name="appShortName" className="form-control" id="appShortName" onChange={handleInputChange} placeholder="" value={inputs.appShortName} disabled={!addOrRegisterApp} />
                            {errors.appShortName && <span className="input-err-msg">{errors.appShortName}</span>}
                        </div>
                        {!props.registerPermission &&
                            <div className="row form-group">
                                <label htmlFor="secret">{properties.FormFieldNames.secret.fieldName}<span>*</span></label>
                                <input type="text" name="secret" className="form-control" id="secret" onChange={handleInputChange} placeholder="" disabled={true} value={inputs.secret} />
                                {errors.secret && <span className="input-err-msg">{errors.secret}</span>}
                            </div>
                        }
                        <div className="row form-group">
                            <label htmlFor="userId">{properties.FormFieldNames.userId.fieldName}<span>*</span></label>
                            <select className="form-control" name="userId" id="userId" value={inputs["userId"]} onChange={handleInputChange} disabled={!props.editPermission && !props.addPermission && !props.registerPermission} >
                                <option value="" disabled={true}>{properties.SELECT}</option>
                                <GenerateDropdownOptions dataList={clientAdmins} />
                            </select>
                            {errors.userId && <span className="input-err-msg">{errors.userId}</span>}
                        </div>
                        {(!props.registerPermission && !(props.addPermission && props.role === properties.dbRoleList.WPS_ADMIN)) &&
                            <div className="row form-group">
                                <label htmlFor="status">{properties.FormFieldNames.status.fieldName}<span>*</span></label>
                                <select className="form-control" name="status" id="status" value={inputs["status"]} onChange={handleInputChange} disabled={!props.editPermission && !props.addPermission && !props.registerPermission} >
                                    <option value="" disabled={true}>{properties.SELECT}</option>
                                    <GenerateDropdownOptions dataList={statusOptionList} />
                                </select>
                                {errors.status && <span className="input-err-msg">{errors.status}</span>}
                            </div>
                        }
                        <div className="row form-group">
                            <label htmlFor="template">{properties.FormFieldNames.template.fieldName}{isTargetMandatory && <span>*</span>}</label>
                            <textarea type="text" name="template" className="form-control textareaField" id="template" onChange={handleInputChange} placeholder="" value={inputs.template} disabled={!props.editPermission && !props.addPermission && !props.registerPermission} ></textarea>
                            {(isTargetMandatory && errors.template) && <span className="input-err-msg">{errors.template}</span>}
                        </div>
                        <div className="row form-group">
                            <label htmlFor="targetUrl">{properties.FormFieldNames.targetUrl.fieldName}{isTargetMandatory && <span>*</span>}</label>
                            <input type="text" name="targetUrl" className="form-control" id="targetUrl" onChange={handleInputChange} placeholder="" value={inputs.targetUrl} disabled={!props.editPermission && !props.addPermission && !props.registerPermission} />
                            {(isTargetMandatory && errors.targetUrl) && <span className="input-err-msg">{errors.targetUrl}</span>}
                        </div>
                        <div className="row form-group">
                            <label htmlFor="lansaUrl">{properties.FormFieldNames.lansaUrl.fieldName}</label>
                            <input type="text" name="lansaUrl" className="form-control" id="lansaUrl" onChange={handleInputChange} placeholder="" value={inputs.lansaUrl} disabled={!props.editPermission && !props.addPermission && !props.registerPermission} />
                            {errors.lansaUrl && <span className="input-err-msg">{errors.lansaUrl}</span>}
                        </div>
                        <div className="row form-group">
                            <label htmlFor="dynamicPaymentMethodConfigurations">{properties.FormFieldNames.dynamicPaymentMethodConfigurations.fieldName}</label>
                            <Tooltip text="Please Enter in format: pmc_id1:region_name1;pmc_id2:region_name2">
                               <FaInfoCircle />
                            </Tooltip>
                            <input type="text" name="dynamicPaymentMethodConfigurations" className="form-control" id="dynamicPaymentMethodConfigurations" onChange={handleInputChange} placeholder="" value={ValueForDynamicPMC(inputs.dynamicPaymentMethodConfigurations)} disabled={!props.editPermission && !props.addPermission && !props.registerPermission} />
                            {errors.dynamicPaymentMethodConfigurations && <span className="input-err-msg">{errors.dynamicPaymentMethodConfigurations}</span>}
                        </div>
                        <div className="row form-group">
                            <div className="checkbox-row">
                                <div className="checkboxContainer">
                                    <label className="checkboxContainerLabel" htmlFor="overCaptureFlag" key="overCaptureFlag">
                                        <input type="checkbox" id='overCaptureFlag' disabled={!props.editPermission && !props.addPermission && !props.registerPermission}
                                            name="overCaptureFlag" value={inputs.overCaptureFlag} className="accordionCheckBox"
                                                defaultChecked={inputs.overCaptureFlag} onChange={(e) => {
                                                    e.persist = () => { }
                                                    onChangeOverCapture(e);
                                                }} />
                                        <span className="checkmark"></span>
                                        <span className="checkboxContainerLabel">
                                            {properties.FormFieldNames.overCaptureFlag.fieldName}
                                        </span> 
                                    </label>
                                    <Tooltip text="This flag allows to capture more than the amount that requested for payment for a certain limit">
                                        <FaInfoCircle />
                                    </Tooltip> 
                                </div>
                            </div>
                        </div>
                        {(inputPaymentsData && (inputPaymentsData.length > 0)) && (
                            <div className="row form-group">
                                <label className="paymentMethodLabel">{properties.FormFieldNames.paymentDTOs.fieldName}<span>*</span></label>
                                <PaymentMethodAccordion appId={appId} paymentMethodList={paymentMethodList} disabled={!props.editPermission && !props.addPermission && !props.registerPermission} onChangePaymentMethod={onChangePaymentMethod} inputPaymentsData={inputPaymentsData} />
                                {errors.paymentDTOs && <span className="input-err-msg">{errors.paymentDTOs}</span>}
                            </div>
                        )}
                        <div className="btn-grp">
                            {props.approvalPermission && <button type="button" className="btn white-btn" data-confirm={properties.DECLINE} onClick={openModal}>{properties.DECLINE}</button>}
                            {props.approvalPermission && <button type="button" className="btn blue-btn" data-confirm={properties.APPROVE} onClick={openModal}>{properties.APPROVE}</button>}
                            <button type="button" className="btn white-btn back-btn" onClick={cancelRegister}>{(props.editPermission || props.addPermission || props.registerPermission || props.rollbackPermission) ? properties.CANCEL : properties.BACK}</button>
                            {props.promotePermission && <button type="button" className="btn blue-btn" data-confirm={properties.PROMOTE} onClick={openModal}>{properties.PROMOTE}</button>}
                            {props.editPermission && <button type="submit" className="btn blue-btn">{properties.SAVE}</button>}
                            {props.addPermission && <button type="submit" className="btn blue-btn">{properties.ADD}</button>}
                            {props.registerPermission && <button type="submit" className="btn blue-btn">{properties.REGISTER}</button>}
                            {props.rollbackPermission && <button type="button" className="btn blue-btn" data-confirm={properties.REVERT} onClick={openModal}>{properties.CONFIRM}</button>}
                        </div>
                    </form>
                </div> :
                showPageNotFound && <PageNotFound />
            }
        </>
    )
}